import { Flex, Heading, Image, useMediaQuery } from "@chakra-ui/react";
import header from "assets/images/svgs/backgroundHeader.svg";
import HeaderNavegation from "./components/HeaderNavegation";
import useWindowDimensions from "core/helpers/windowDimensions";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import colors from "core/resources/theme/colors";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const headerHeight = Math.min(450, Math.max(130, width / 5));
  const [isLargerThan1024] = useMediaQuery("(min-width: 1025px)");

  return (
    <Flex
      bgImage={header}
      bgRepeat="no-repeat"
      bgSize="100%"
      position="absolute"
      w="100vw"
      h={headerHeight}
      zIndex={99999}
    >
      <Flex
        flexDir="row"
        align="flex-start"
        w="100%"
        py={[2, 0, 4, 8]}
        ml={[0, 0, 0, 0, 16]}
        gap={[0, 0, 4]}
      >
        <Image
          src="https://tactonuvem.blob.core.windows.net/imagens/900b34b0-9d5d-4e52-b6ed-80d9c42d8825/banners/logoacquapark-01.png"
          maxWidth={["90px", "100px", "150px", "200px", "250px"]}
          cursor="pointer"
          onClick={() => navigate("/")}
        />
        {!isLargerThan1024 && (
          <Heading
            fontFamily="SuperMoodsRegular"
            fontSize={["lg", "xl", "3xl", "4xl"]}
            color={colors.newBlue}
            fontWeight="bold"
          >
            SEU DIA MAIS FELIZ
          </Heading>
        )}
      </Flex>
      <Flex justify="flex-end" py={[2, 8]} mr={[4, 32]} position="relative">
        <HeaderNavegation isOpen={isOpen} setIsOpen={setIsOpen} />
      </Flex>
    </Flex>
  );
}
